/* eslint-disable react/prop-types */
//new in Braun
import React from 'react'
import {Icon} from '@chakra-ui/react'

const CloseLabelIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" style={{'--current-fill': props.fill}} {...props}>
            <circle cx="20" cy="20" r="20" fill="var(--current-fill)" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.9395 27.0607L12.9395 15.0607L15.0608 12.9393L27.0608 24.9393L24.9395 27.0607Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.0605 27.0607L27.0605 15.0607L24.9392 12.9393L12.9392 24.9393L15.0605 27.0607Z"
                fill="white"
            />
        </Icon>
    )
}

export default CloseLabelIcon
